/**
 * Utility function which wraps javascript URL object. It preserves entire url (including pathname) of origin¨
 */
export var getSafeUrl = function getSafeUrl(path, origin) {
  var originUrl = new URL(origin.endsWith('/') ? origin : "".concat(origin, "/"));

  // Get pathname from origin as prefix and get path without leading slash
  var newPathname = "".concat(originUrl.pathname).concat(path.slice(1));
  var newUrl = new URL(newPathname, originUrl.origin);
  return newUrl;
};